// --------------------------------------- Project List
import img1 from "../Assets/image1.png";
import img2 from "../Assets/image2.png";
import img3 from "../Assets/image3.png";

export const ProjectList = [
  {
    id: 1,
    img: img1,
    title: "Favitech Team",
    description: "I belong to a team of developers and made a large contribution towards the development of our joint portfolio.",
    tech_stack: "Html, Css, Scss, Javascript",
    github_url: "https://github.com/CoderFaveX/favitech.git",
    demo_url: "https://favitech.vercel.app",
  },
  {
    id: 2,
    img: img2,
    title: "Portfolio Templates",
    description:
      "An online portfolio template. Great to practice flex/grid layouts, absolute positioning and sliders.",
    tech_stack: "React, Css, Scss",
    github_url: "https://github.com/CoderFaveX/reactfolio.git",
    demo_url: "https://reactfolio-psi.vercel.app",
  },
  {
    id: 3,
    img: img3,
    title: "Portfolio",
    description: "Of course I made my own personal portfolio website.",
    tech_stack: "React, Css, Scss",
    github_url: "https://github.com/CoderFaveX/portfolio-react.git",
    demo_url: "",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/html5.svg",
    name: "HTML",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/css3.svg",
    name: "CSS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/javascript.svg",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/react.svg",
    name: "ReactJS",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/bootstrap.svg",
    name: "Bootstrap",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/sass.svg",
    name: "Scss",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/git.svg",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/gurupawar/website/main/src/Assets/skill/responsive.svg",
    name: "Responsive",
  },
];
